import { SalaryComponentCalculation } from "@tymbe/legislatives/SalaryComponentCalculation";

export const salaryComponentCalculationIntentionNameMap: Record<SalaryComponentCalculation, string> = {
  [SalaryComponentCalculation.GrossWork]: "K hrubé mzdě",
  [SalaryComponentCalculation.GrossExtra]: "K odměně",
  [SalaryComponentCalculation.Net]: "K čisté mzdě",
  [SalaryComponentCalculation.Payable]: "K částce k vyplacení",
}
